export const PERIODIC_REPORTS_PARAMS = {
    'LOCATION': 'LOCATION',
    'POINT': 'POINT',
    'EMPLOYEE': 'EMPLOYEE',
    'CLIENT': 'CLIENT'
};
